export const TRANSLATIONS_ES_GENERATION = {
  "generate.title": "Generar documento",
  "generate.subtitle": "Resumen ejecutivo desde fuentes seleccionadas",
  "generate.action": "Generar",
  "generate.generating": "Generando...",
  "generate.sources.title": "Fuentes",
  "generate.sources.clear": "Limpiar seleccion",
  "generate.sources.loading": "Cargando documentos...",
  "generate.language": "Idioma",
  "generate.expertRole": "Experto",
  "generate.expertRole.general": "General",
  "generate.message.label": "Mensaje para el resumen (opcional)",
  "generate.message.placeholder": "Ej.: enfócate en riesgos y próximos pasos…",
  "generate.message.counter": "{count}/{max}",
  "generate.validation.selectSource": "Selecciona al menos una fuente.",
  "generate.toast.success": "Borrador generado.",
  "generate.toast.enqueued": "Generación en cola. Estará lista en unos minutos; te avisaremos.",
  "generate.errors.documents": "No se pudieron cargar los documentos.",
  "generate.errors.forbidden": "Tu plan no permite generar documentos o la cuota fue alcanzada.",
  "generate.errors.insufficientEvidence": "La evidencia seleccionada no es suficiente.",
  "generate.errors.generic": "No se pudo generar el documento.",
  "generate.errors.download": "No se pudo descargar el PDF.",
  "generate.picker.title": "¿Qué documentos quieres seleccionar para generar tu resumen?",
  "generate.picker.searchPlaceholder": "Buscar documentos…",
  "generate.picker.empty": "No se encontraron documentos.",
  "generate.picker.selected": "seleccionados",
  "generate.picker.confirm": "Listo",
  "generate.picker.open": "Seleccionar documentos",
  "generate.sources.empty": "Aún no has seleccionado documentos. Usa «Seleccionar documentos» para elegirlos.",
  "generate.warnings.sourcesUnavailable": "Algunas fuentes ya no están disponibles y se descartaron. Vuelve a consultarlas si las necesitas.",
  "generate.preview.title": "Vista previa",
  "generate.preview.empty": "Selecciona fuentes y genera el borrador.",
  "generate.download": "Descargar PDF",
  "generate.downloading": "Descargando...",
  "generate.mySummaries": "Documentos Generados",
  "generate.history.title": "Documentos Generados",
  "generate.history.subtitle": "Histórico de resúmenes ejecutivos generados",
  "generate.export.docx": "Descargar DOCX",
  "generate.export.draftWatermark": "La descarga incluirá la marca de agua BORRADOR (documento no aprobado)",
  "generate.history.notify.ready": "Tu resumen ejecutivo está listo.",
  "generate.history.notify.failed": "No se pudo generar el resumen.",
  "generate.history.pagination.label": "Paginación",
  "generate.history.pagination.prev": "Anterior",
  "generate.history.pagination.next": "Siguiente",
  "generate.history.unnamedDocument": "Documento",
  "generate.history.enqueuedBanner": "Tu resumen se está generando en segundo plano. Te avisaremos cuando esté listo; puedes seguir trabajando.",
  "generate.history.dismiss": "Cerrar",
  "generate.history.new": "Nuevo resumen",
  "generate.history.col.files": "Archivos",
  "generate.history.col.created": "Creado",
  "generate.history.col.status": "Estado",
  "generate.history.col.expert": "Experto",
  "generate.history.expert.general": "General",
  "generate.history.col.actions": "Acciones",
  "generate.history.status.downloaded": "Descargado",
  "generate.history.status.pending": "Pendiente",
  "generate.history.status.processing": "Procesando",
  "generate.history.status.completed": "Completado",
  "generate.history.status.failed": "Fallido",
  "generate.history.action.download": "Descargar PDF",
  "generate.history.action.regenerate": "Regenerar",
  "generate.history.empty": "Aún no has generado resúmenes.",
  "generate.history.emptyCta": "Generar mi primer resumen",
  "generate.history.loading": "Cargando resúmenes...",
  "generate.history.error": "No se pudieron cargar los resúmenes.",
  "generate.history.retry": "Reintentar",
  "generate.history.moreFiles": "+{count}",
  "generate.history.col.message": "Mensaje",
  "generate.history.noMessage": "—",
  "generate.lifecycle.tabs.label": "Filtrar por estado",
  "generate.lifecycle.tab.all": "Todos",
  "generate.lifecycle.tab.draft": "Borradores",
  "generate.lifecycle.tab.in_review": "En revisión",
  "generate.lifecycle.tab.approved": "Aprobados",
  "generate.lifecycle.tab.rejected": "Rechazados",
  "generate.lifecycle.tab.archived": "Archivados",
  "generate.lifecycle.status.draft": "Borrador",
  "generate.lifecycle.status.in_review": "En revisión",
  "generate.lifecycle.status.approved": "Aprobado",
  "generate.lifecycle.status.rejected": "Rechazado",
  "generate.lifecycle.status.archived": "Archivado",
  "generate.lifecycle.col.version": "Versión",
  "generate.lifecycle.action.submit": "Enviar a revisión",
  "generate.lifecycle.action.approve": "Aprobar",
  "generate.lifecycle.action.reject": "Rechazar",
  "generate.lifecycle.action.archive": "Archivar",
  "generate.lifecycle.action.timeline": "Ver historial de cambios",
  "generate.lifecycle.action.revise": "Corregir y reenviar",
  "generate.lifecycle.action.unarchive": "Restaurar",
  "generate.lifecycle.confirm.title": "Confirmar acción",
  "generate.lifecycle.confirm.submit": "¿Enviar este resumen a revisión?",
  "generate.lifecycle.confirm.approve": "¿Aprobar este resumen? Quedará marcado como contenido revisado.",
  "generate.lifecycle.confirm.archive": "¿Archivar este resumen? Dejará de estar activo.",
  "generate.lifecycle.confirm.cancel": "Cancelar",
  "generate.lifecycle.confirm.accept": "Confirmar",
  "generate.lifecycle.reject.title": "Rechazar resumen",
  "generate.lifecycle.reject.reasonLabel": "Motivo del rechazo (obligatorio)",
  "generate.lifecycle.reject.placeholder": "Explica por qué se rechaza este resumen...",
  "generate.lifecycle.reject.confirm": "Rechazar",
  "generate.lifecycle.confirm.revise": "¿Devolver este resumen a borrador para corregirlo? Podrás enviarlo a revisión de nuevo.",
  "generate.lifecycle.confirm.unarchive": "¿Restaurar este resumen archivado? Volverá a borrador.",
  "generate.lifecycle.toast.submitted": "Resumen enviado a revisión.",
  "generate.lifecycle.toast.approved": "Resumen aprobado.",
  "generate.lifecycle.toast.rejected": "Resumen rechazado.",
  "generate.lifecycle.toast.archived": "Resumen archivado.",
  "generate.lifecycle.toast.revised": "Resumen devuelto a borrador.",
  "generate.lifecycle.toast.unarchived": "Resumen restaurado a borrador.",
  "generate.lifecycle.toast.error": "No se pudo completar la acción. Inténtalo de nuevo.",
  "generate.detail.view": "Ver detalle",
  "generate.detail.title": "Detalle del resumen",
  "generate.detail.close": "Cerrar",
  "generate.detail.empty": "Este resumen no tiene contenido para mostrar.",
  "generate.lifecycle.timeline.title": "Historial de cambios de estado",
  "generate.lifecycle.timeline.empty": "Sin transiciones registradas.",
  "generate.lifecycle.timeline.error": "No se pudo cargar el historial de cambios.",
  "generate.lifecycle.timeline.close": "Cerrar",
  "generate.lifecycle.generatedByAi": "Contenido generado por IA: revísalo antes de usarlo como documento oficial.",
  "generate.lifecycle.draftBadge": "BORRADOR — no aprobado",
};
